module.exports = __webpack_public_path__ + "img/coin7.c255608.webp";